import { H5, Image, LI, P, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Link } from "react-router-dom";
import { TRACK_ORDER_DATA } from "../../../../Data/Dashboard";

export const TrackOrderList = () => {
  return (
    <UL className="track-order simple-list">
      {TRACK_ORDER_DATA.map((item, index) => (
        <LI key={index}>
          <div className="d-flex">
            <div className={`flex-shrink-0 ${item.imageClass ? item.imageClass : ""}`}>
              <Image src={dynamicImage(`dashboard-2/total-icon/${item.image}`)} alt="" />
            </div>
            <div className="flex-grow-1">
              <div className="d-flex justify-content-between">
                <Link to={`${process.env.PUBLIC_URL}/chat/chat`}>
                  <H5>{item.tag}</H5>
                  <P className="text-truncate">{item.text}</P>
                </Link>
                <span className="font-primary f-w-600">{item.span}</span>
              </div>
            </div>
          </div>
        </LI>
      ))}
    </UL>
  );
};
